import { FC, useEffect, useState } from 'react';

import { defaultLimit } from '@/src/assets/constants/constants';
import { BlogPostInterface } from '@/src/assets/interfaces/blogPostInterface';

import { getBlogPosts } from '@/src/api/api';

import Wrapper from '../../UI/wrapper/Wrapper';
import { BlogPostCard } from '../blogPostCard/BlogPostCard';

import styles from './BlogPosts.module.scss';

interface BlogPostsProps {
    blogPosts: BlogPostInterface[];
    tag: string;
}

const BlogPosts: FC<BlogPostsProps> = ({ blogPosts, tag }) => {
    const [postsData, setPostsData] = useState<BlogPostInterface[]>(blogPosts);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(defaultLimit);

    const getMorePosts = async (tag: string, offset: number, limit: number) => {
        const postsData = await getBlogPosts(tag, offset, limit);
        setPostsData((prev) => [...prev, ...postsData]);
    };

    useEffect(() => {
        if (offset !== 0) {
            getMorePosts(tag, offset, limit);
        }
    }, [tag, offset, limit]);

    return (
        <Wrapper>
            <div className={styles.postsContainer}>
                {postsData.map((post) => {
                    return <BlogPostCard key={post._id} post={post} />;
                })}
            </div>
        </Wrapper>
    );
};

export { BlogPosts };
